(ns manage.ad-variant.page.table-util
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/FormControlLabel$default" :as FormControlLabel]
            ["@mui/material/Radio$default" :as Radio]
            ["@mui/material/RadioGroup$default" :as RadioGroup]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.set :as set]
            [clojure.string :as str]
            [common.widgets.data-grid :as dg]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [manage.ad-variant.data :as variant-data]
            [manage.adset.hooks :refer [use-adset-formats]]
            [mate.core :as mc]
            [reagent.core :as r]
            [uix.core :refer [$ defui]]))

(defui status-select-filter
  [{:keys [filter-model set-filter-model]}]
  (let [filter-id "status"
        status->group (fn [status]
                        (or (some (fn [[group statuses]]
                                    (when (contains? statuses status)
                                      group))
                                  variant-data/status-filter-groups)
                            status))

        single-filters (->> variant-data/status
                            (remove (fn [[status _]]
                                      (contains? (apply set/union (vals variant-data/status-filter-groups)) status)))
                            (mapv (fn [[status {:keys [title]}]]
                                    {:value status
                                     :label title})))

        grouped-filters (->> variant-data/status-filter-groups
                             (mapv (fn [[group _]]
                                     {:value group
                                      :label (str/capitalize group)})))

        filters (concat single-filters grouped-filters)

        dropdown-value (->> (->clj filter-model)
                            :items
                            (filter #(= filter-id (:id %)))
                            first
                            :value
                            (map status->group)
                            set)]
    ($ form-field {:label "Status"}
       (r/as-element
        [dropdown {:data-testid "statusFilterSelect"
                   :disableCloseOnSelect true
                   :render-checkboxes? true
                   :multi? true
                   :options filters
                   :value dropdown-value
                   :on-change (fn [value]
                                (let [new-filter-field-value
                                      (->> value
                                           (reduce (fn [acc s]
                                                     (set/union acc (or (get variant-data/status-filter-groups s) #{s})))
                                                   #{}))
                                      new-filter-model
                                      (-> filter-model
                                          (->clj)
                                          (dg/remove-field filter-id)
                                          (cond-> (seq new-filter-field-value)
                                            (update :items conj
                                                    {:id filter-id
                                                     :field filter-id
                                                     :operator "isAnyOf"
                                                     :value new-filter-field-value})))]
                                  (set-filter-model (->js new-filter-model))))}]))))

(defui template-radio-filter
  [{:keys [height-field width-field format-field label data-testid filter-model set-filter-model]
    :or {label "Template"
         data-testid "templateFilterSelect"
         width-field "width"
         height-field "height"
         format-field "ad-type"}}]
  (let [filter-options (->> (use-adset-formats)
                            (mapv (fn [{:keys [ad-type width height]}]
                                    {:value (str ad-type "-" width "x" height)
                                     :label (variant-data/template-info
                                             {:ad-type ad-type
                                              :dimensions {:width width :height height}})
                                     :data [ad-type width height]})))

        filter-on-format? (->> filter-options
                               (map (comp first :data))
                               set
                               count
                               (< 1))

        filter-options-by-value (mc/index-by :value filter-options)

        all-templates-option-id "all-templates"

        items-by-id (-> (->clj filter-model)
                        :items
                        (->> (mc/index-by :id)))
        selected-option-id (if (and (contains? items-by-id width-field)
                                    (contains? items-by-id height-field)
                                    (or (not filter-on-format?)
                                        (contains? items-by-id format-field)))
                             (get-in items-by-id [width-field :filter-option-id])
                             all-templates-option-id)
        on-change (fn [^js event]
                    (let [selected-option-id (-> event .-target .-value)
                          [format width height] (-> selected-option-id filter-options-by-value :data)
                          new-filter-items (cond-> [{:id width-field
                                                     :filter-option-id selected-option-id
                                                     :operator "equals"
                                                     :field width-field
                                                     :value (str width)}
                                                    {:id height-field
                                                     :operator "equals"
                                                     :field height-field
                                                     :value (str height)}]
                                             filter-on-format?
                                             (conj {:id format-field
                                                    :operator "isAnyOf"
                                                    :field format-field
                                                    :value [format]}))
                          new-filter-model (-> filter-model
                                               ->clj
                                               (dg/remove-field width-field)
                                               (dg/remove-field height-field)
                                               (cond-> filter-on-format? (dg/remove-field format-field))
                                               (cond-> (not= selected-option-id all-templates-option-id)
                                                 (update :items concat new-filter-items))
                                               ->js)]
                      (set-filter-model new-filter-model)))]
    ($ form-field {:label label}
       ($ Box {:sx #js {:ml 0.5}}
          ($ RadioGroup {:value selected-option-id
                         :name data-testid
                         :on-change on-change}
             ($ FormControlLabel {:value all-templates-option-id
                                  :control ($ Radio)
                                  :label "All"})
             (for [option filter-options]
               ($ FormControlLabel {:key (:value option)
                                    :value (:value option)
                                    :control ($ Radio)
                                    :label (:label option)})))))))

(defui ad-variant-table-filters []
  ($ Box {:sx #js {:mr "auto"}}
     ($ dg/filters-button
        {:variant :ocp
         :custom-filter-components [{:component status-select-filter
                                     :id "status-select-filter"}
                                    {:component template-radio-filter
                                     :id "template-radio-filter"}]})))
